// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xSlL","content":"styles_content__pYXu4","row":"styles_row__2l3ee","footer":"styles_footer__3rg2J","phraseLength":"styles_phraseLength__2j1Vt"};